import { render, staticRenderFns } from "./theatre.vue?vue&type=template&id=4627d47a&scoped=true&"
import script from "./theatre.vue?vue&type=script&lang=js&"
export * from "./theatre.vue?vue&type=script&lang=js&"
import style0 from "./theatre.vue?vue&type=style&index=0&id=4627d47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4627d47a",
  null
  
)

export default component.exports